import { FiltersConfigTemplateElement } from "PFTypes/filters_config";
import { useMemo } from "react";
import { useFormContext } from "react-hook-form";

type UseIsFieldRequiredProps = {
  fieldPrefix: string;
  template: FiltersConfigTemplateElement;
};

export const useIsFilterReadOnly = ({ fieldPrefix, template }: UseIsFieldRequiredProps) => {
  const { getValues } = useFormContext();
  const filterName = getValues(`${fieldPrefix}.name`);
  return useMemo(() => template.readonly_names?.includes(filterName), [filterName, template.readonly_names]);
};
